import { render, staticRenderFns } from "./GoodsForm.vue?vue&type=template&id=49e6eaa8"
import script from "./GoodsForm.vue?vue&type=script&lang=js"
export * from "./GoodsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49e6eaa8')) {
      api.createRecord('49e6eaa8', component.options)
    } else {
      api.reload('49e6eaa8', component.options)
    }
    module.hot.accept("./GoodsForm.vue?vue&type=template&id=49e6eaa8", function () {
      api.rerender('49e6eaa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/shop/GoodsForm.vue"
export default component.exports